import {
  Gear,
  House,
  UserCircle,
  CircleWavyCheck,
  Exam,
  ChatCenteredText,
  BagSimple,
  ListNumbers,
  GraduationCap,
  Books,
  ChartBarHorizontal,
  IdentificationBadge,
  Scroll,
  ChatTeardropDots,
  Student,
  List,
  Notebook,
  Files,
  TextAlignCenter,
  BookOpen,
  Note,
  ListBullets,
  UsersThree,
  Lightning,
  CalendarBlank,
  User,
  Table,
  Ranking,
  Binary,
  Notepad,
  NotePencil,
  UserSquare,
  Lectern,
  SquaresFour,
} from '@/app/images';

export const menuIcon: Map<string, React.ReactNode> = new Map([
  ['main', House],
  ['profile', UserCircle],
  ['current-superintendence', CircleWavyCheck],
  ['certification-results', Exam],
  ['msg', ChatCenteredText],
  ['employment', BagSimple],
  ['settings', Gear],
  ['sdchoice2021admin', ListNumbers],
  ['sdchoice2021moderator', ListNumbers],
  ['sdchoice2021nmv', ListNumbers],
  ['vedomost', GraduationCap],
  ['mob', Books],
  ['vote', ChartBarHorizontal],
  ['contacts', IdentificationBadge],
  ['notice-board', Scroll],
  ['msg', ChatTeardropDots],
  ['kurator', Student],
  ['rnp', List],
  ['studysheet', CircleWavyCheck],
  ['rectorialcontrol', CircleWavyCheck],
  ['pk2024', Notebook],
  ['pk2025', Notebook],
  ['studdoc', Files],
  ['plans_individual', TextAlignCenter],
  ['journals', BookOpen],
  ['np', Note],
  ['lists', ListBullets],
  ['sessiyaNPP', UsersThree],
  ['plans', Lightning],
  ['attestation', CalendarBlank],
  ['vedomost', GraduationCap],
  ['vidpovidalniy', User],
  ['reytinghelp', Table],
  ['ratingnpp2021', Ranking],
  ['ratingnpp2022', Ranking],
  ['ratingnpp2023', Ranking],
  ['ratingnpp2024', Ranking],
  ['webometrics', Binary],
  ['attestationresults', Notepad],
  ['ekanat', Student],
  ['editRNP', NotePencil],
  ['hignyak', List],
  ['rnpedit', NotePencil],
  ['rnpupd', NotePencil],
  ['rnpupd2', NotePencil],
  ['voteresult', Notepad],
  ['vedomostadmin', UserSquare],
  ['zvit', UserSquare],
  ['zamdekan', UserSquare],
  ['zavkaf', UserSquare],
  ['zdekan', Lectern],
  ['ekk', Notebook],
  ['bravook', Scroll],
  ['ratingnpp', Ranking],
  ['pk2024admin', Notebook],
  ['pk2025admin', Notebook],
  ['studdocadmin', Files],
  ['yiystat', Table],
  ['adminpanel', SquaresFour],
  ['useract', Scroll],
  ['viewcontrol', NotePencil],
  ['_group.rating', Ranking],
]);
